import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export interface TeamMember {
  id: string;
  name: string;
  email: string;
}

/** Gedeelde teamledenlijst voor het delen van preekinhoud/privé-notities met
 * een voorganger, coach of medespreker. Zelfde implementatie als
 * modules/leiderschap/hooks/useTeamMembers.ts. */
export default function useTeamMembers() {
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);

  useEffect(() => {
    let active = true;
    axios
      .get<TeamMember[]>(`${API}/team`)
      .then((response) => {
        if (active) setTeamMembers(response.data);
      })
      .catch(() => {
        if (active) setTeamMembers([]);
      });
    return () => {
      active = false;
    };
  }, []);

  return teamMembers;
}
